<template>
    <div class="loading-overlay">
    <div class="mt-4">
        <div class="loading-spinner" aria-label="Loading">
            <div class="loading-spinner__item loading-spinner__item--1"></div>
            <div class="loading-spinner__item loading-spinner__item--2"></div>
            <div class="loading-spinner__item loading-spinner__item--3"></div>
        </div>
    </div>
    </div>
</template>

<script setup lang="ts">

</script>